<template>
  <div class="content">
    <div class="left">
      <Badge :status="statusType" />
    </div>
    <div class="right">
      <div class="row">
        <div class="left color2">
          <Icon type="md-bookmark" />{{row.brandName}}</div>
        <div class="right">
          <!--  :color="companyStateColor" -->
          <Tag type="border" style="cursor: text;">{{companyStateLabel}}</Tag>
        </div>
      </div>
      <div class="row">
        <div class="left color3">
          <Icon type="md-home" />{{row.companyName}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import dics from './dics'
export default {
  components: {},
  props: {
    row: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      msg: null,
      companyStateLabel: null,
      companyStateColor: '',
      statusType: ''
    }
  },
  computed: {},
  created() {
    this.getState()
  },

  methods: {
    getState() {
      let companyState = this.row.companyState
      let txt = ''
      dics.companyStateData.forEach(item => {
        if (String(item.value) === String(companyState)) {
          txt = item.label
        }
      })
      this.companyStateLabel = txt
      // let colorObj = {
      //   '0': '#ff9900',
      //   '1': '#2db7f5',
      //   '2': '#515a6e',
      //   '3': '#19be6b'
      // }
      let colorObj = {
        '0': 'yellow',
        '1': 'blue',
        '2': 'pink',
        '3': 'lime'
      }
      let statusTypeObj = {
        '0': 'warning',
        '1': 'processing',
        '2': 'error',
        '3': 'success'
      }
      
      let key = String(companyState)
      this.companyStateColor = colorObj[key] || 'cyan'
      this.statusType = statusTypeObj[key] || 'cyan'
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  display: flex;
  flex-direction: row;

  .left {
    flex-basis: 20px;
    display: flex;
    align-items: center;
  }

  .right {
    flex: 1;
  }
}

.color1 {
  color: #17233d;
}

.color2 {
  color: #515a6e;
}

.color3 {
  color: #808695;
}

.color4 {
  color: #c5c8ce;
}

.row {
  display: flex;
  flex-direction: row;

  .left {
    flex: 1;
  }

  .right {
    flex: 1;
    text-align: right;
  }
}
</style>